import * as React from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import {
  TextFieldStyled,
  BoxStyled,
  IconButtonStyled,
  TypographyStyledSubHead
} from './styles';

export const NumberInput = ({
  subHeading,
  marginVal,
  incrementDecrementVal = 1,
  plusSymbolRequired = false,
  decimalRequired = true,
  range = { min: 0, max: 100000000 },
  value,
  setValue
}: {
  subHeading?: string;
  marginVal?: string;
  incrementDecrementVal?: number;
  plusSymbolRequired?: boolean;
  decimalRequired?: boolean;
  value: number;
  range?: { min: number; max: number };
  setValue: (val: number) => void;
}) => {
  const [updatedVal, setUpdatedVal] = React.useState<string | number>(value);
  React.useEffect(() => {
    setInputVal(value);
  }, [value]);

  const setInputVal = (value: number) => {
    const param = Number(Number(value).toFixed(2));
    const setNum = plusSymbolRequired && param > 0 ? '+' + param : param;
    setUpdatedVal(setNum);
  };

  const handleBlur = (event: any) => {
    const newValue = event.target.value;
    let setVal = range.min;
    if (
      (subHeading === '(months)' ||
        subHeading === '(in)' ||
        subHeading === '(lb)') &&
      range.max <= newValue
    ) {
      setVal = range.max - 1;
    } else if (newValue < range.min) {
      setVal = range.min;
    } else if (range.max < newValue) {
      setVal = range.max;
    } else if (!isNaN(newValue)) {
      setVal = newValue;
    }
    setInputVal(setVal);
    setValue(Number(Number(setVal).toFixed(2)));
  };

  const handleChange = (event: any) => {
    const newValue = event.target.value;
    if (decimalRequired) {
      //for  positive, negative, decimals
      if (/^[-+]?\d*(\.\d*)?$/.test(newValue)) {
        setUpdatedVal(newValue);
      }
    } else {
      //for age
      if (!isNaN(newValue)) {
        setUpdatedVal(Number(newValue));
      } else if (newValue === '-' || newValue === '+') {
        setUpdatedVal(newValue);
      }
    }
  };

  const handleIncrement = () => {
    if (range.max > Number(value)) {
      setValue(
        Number(value) + incrementDecrementVal > range.max
          ? range.max
          : Number((Number(value) + incrementDecrementVal).toFixed(2))
      );
    }
  };

  const handleDecrement = () => {
    if (Number(value) > range.min) {
      setValue(
        Number(value) - incrementDecrementVal >= range.min
          ? Number((Number(value) - incrementDecrementVal).toFixed(2))
          : range.min
      );
    }
  };

  return (
    <div style={{ marginRight: marginVal, width: '100%' }}>
      <TypographyStyledSubHead>{subHeading}</TypographyStyledSubHead>
      <TextFieldStyled
        type="text"
        value={updatedVal}
        disabled={range.min === range.max}
        onChange={handleChange}
        onBlur={handleBlur}
        variant="outlined"
        size="small"
        inputProps={{ 'data-testid': 'textBox', 'aria-label': 'input-field' }}
      />
      <BoxStyled>
        <IconButtonStyled
          onClick={handleDecrement}
          disabled={updatedVal === range.min}
          aria-label="decrement"
          sx={{ marginRight: '1.5625rem' }}
          data-testid="decrement"
        >
          <RemoveIcon />
        </IconButtonStyled>
        <IconButtonStyled
          onClick={handleIncrement}
          disabled={updatedVal === range.max}
          aria-label="increment"
          sx={{ marginLeft: '1.5625rem' }}
          data-testid="increment"
        >
          <AddIcon />
        </IconButtonStyled>
      </BoxStyled>
    </div>
  );
};
